// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  visibleProjectileId: __t.string().name("visible_projectile_id"),
  playerId: __t.string().name("player_id"),
  matchId: __t.string().name("match_id"),
  projectileId: __t.string().name("projectile_id"),
  x: __t.f64(),
  y: __t.f64(),
  vx: __t.f64(),
  vy: __t.f64(),
  teamIndex: __t.u32().name("team_index"),
  projectileType: __t.string().name("projectile_type"),
  progress: __t.f64(),
  sourceUnitId: __t.option(__t.string()).name("source_unit_id"),
  volleyJson: __t.option(__t.string()).name("volley_json"),
  artilleryJson: __t.option(__t.string()).name("artillery_json"),
});
